export default __webpack_public_path__ + "static/media/promos-icon.74457575.webp";